import { render, staticRenderFns } from "./FormationStatusLabel.vue?vue&type=template&id=58165b3b&scoped=true&"
import script from "./FormationStatusLabel.vue?vue&type=script&lang=js&"
export * from "./FormationStatusLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58165b3b",
  null
  
)

export default component.exports